import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import '../../Estilo/StreetViewModal.css'
import { PhotoSphere } from './PhotoSphere'
import { StreetViewData, Image360 } from '../../Screen/MapInitial/MapInitialViewController'

type Props = {
    show: boolean
    data: StreetViewData | null
    onClose: () => void
    onNavigate: (img: Image360, oldImg: number) => void
}

export function StreetViewModal({ show, data, onClose, onNavigate }: Props) {
    const [ready, setReady] = useState(false)
    return (
        <Modal
            show={show}
            onHide={() => {
                setReady(false)
                onClose()
            }}
            onEntered={() => setReady(true)} 
            backdrop="static"
            dialogClassName="streetview-modal"
            contentClassName='streetview-modal-content'
        >
            <Modal.Header closeButton>
                <Modal.Title>Street View</Modal.Title>
            </Modal.Header>

            <Modal.Body className='streetview-modal-body'>
                {ready && data?.main ? (
                    <PhotoSphere
                        main={data.main}
                        secundaries={data.secundaries}
                        onNavigate={onNavigate}
                    />
                )
                    :
                    <div className='d-flex justify-content-center align-items-center h-100'>
                        <h2>Sem imagem disponível </h2>
                    </div>
                }

            </Modal.Body>
        </Modal>
    )
}
